import React from 'react';
import { Grid } from '@mui/material';
import { AnimationsFlash } from '../AnimationsFlash.js';
import { AnimationsGif } from '../AnimationsGif.js';

export function AnimationsPage() {
  return (
    <Grid container spacing={1}>
      <AnimationsFlash />
      <AnimationsGif />
    </Grid>
  );
}
